<div *ngIf="progress && progress > 0" class="progress__bar__container" [ngClass]="classBottom">
    <div class="progress__bar {{className}}" 
        [style.width]="progressBarWidth">
    </div>
</div>
